import countries from './countries';

import type { VATCountry } from './types/VATCountry.type';
import type { VATResult } from 'utils/vat/types/VATResult.type';

class Result {
  public value: string | null;
  public country?: {
    name: string,
    isoCode: {
      short: string,
      long: string,
      numeric: string
    }
  };

  constructor(vat?: string | null, country?: VATCountry | null) {
    this.value = vat || null;

    if (country) {
      this.country = {
        name: country.name,
        isoCode: {
          short: country.codes[0],
          long: country.codes[1],
          numeric: country.codes[2]
        }
      };
    }
  }
}

function removeExtraChars(vat?: string | null): string {
  return (vat || '')
    .toString()
    .toUpperCase()
    .replace(/(\s|-|\.)+/g, '');
}

function isVatValidToRegexp(vat: string, regexArr: Array<RegExp>): boolean {
  for (let i = 0; i < regexArr.length; i++) {
    const regex = regexArr[i];
    const isValid = regex.test(vat);
    if (isValid) {
      return true;
    }
  }

  return false;
}

function getCountry(vat: string, countriesList: Array<VATCountry>): VATCountry | undefined | null {
  return countriesList.find((country) =>
    isVatValidToRegexp(vat, country.regex));
}

export default function checkVAT(vat?: string | null): VATResult {
  if (!vat) {
    throw new Error('VAT should be specified');
  }

  const cleanVAT = removeExtraChars(vat);
  const result = new Result(cleanVAT);

  const country = getCountry(cleanVAT, countries);
  if (!country) {
    return result;
  }

  return new Result(cleanVAT, country);
}
